import { render } from "./LivePhoto.vue?vue&type=template&id=15bb73b7&scoped=true&ts=true"
import script from "./LivePhoto.vue?vue&type=script&lang=ts"
export * from "./LivePhoto.vue?vue&type=script&lang=ts"

import "./LivePhoto.vue?vue&type=style&index=0&id=15bb73b7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bb73b7"]])

export default __exports__